import React from 'react';
import { Form, Input } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';

const Text = ({
    value,
    name,
    onChange,
    onBlur,
    isDisabled,
    hintKey,
    noLabel,
    className,
    text,
    error,
    type,
    datalist: valuesList = [],
    placeholder,
    isRequired,
    autoComplete,
    autoFocus,
    isGrid,
    maxLength, 
}) => {
    const { t } = useTranslation();

    value = value ?? '';

    return (
        <Form.Field>
            {!noLabel ? (
                <label className={isDisabled ? 'label-disabled' : null}>
                    <span
                        dangerouslySetInnerHTML={{
                            __html: `${t(text || name)}${isRequired ? ' *' : ''}`,
                        }}
                    />
                </label>
            ) : null}
            <Input
                placeholder={t(placeholder)}
                list={valuesList && name}
                className={className}
                type={type}
                disabled={isDisabled}
                name={name}
                value={value}
                error={error}
                onChange={onChange}
                onBlur={onBlur}
                autoFocus={autoFocus}
                autoComplete={autoComplete}
                transparent={isGrid}
                style={isGrid && value ? {width: `${(value.length + 1) * 8 + 24}px`} : null}
                maxLength={maxLength}
            />
            {hintKey ? (
                <span className="label-hint">{t(hintKey)}</span>
            ) : null}
            {hintKey && error && typeof error === 'string' && <br/>}
            {error && typeof error === 'string' ? (
                <span className="label-error">{error}</span>
            ) : null}
            {valuesList && valuesList.length ? (
                <datalist id={name}>
                    {valuesList.map(item => (
                        <option key={item.id} value={item.name} />
                    ))}
                </datalist>
            ) : null}
        </Form.Field>
    );
};
export default Text;
